<template>
  <div class="flex-grow-1 d-flex flex-column h-100">
    <filtered-data
      ref="data"
      v-model="data"
      :endpoint="'machines/' + id + '/eva'"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h2 class="page-heading mr-auto">EVA-DTS отчеты</h2>
      <btn-action class="btn btn-sm btn-outline-primary mr-2" @click="sendEva">
        Запросить отчет
      </btn-action>
      <btn-action
        class="btn btn-sm btn-outline-danger"
        @click="deleteInvalids"
        v-if="$root.user.role.name !== 'lessor_pro'"
      >Удалить все отчёты с ошибкой</btn-action>
      <btn-action
        class="btn btn-sm btn-outline-danger ml-2"
        @click="deleteAll"
        v-if="$root.isAdmin()"
      >Удалить все отчёты</btn-action>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @row-click="((row) => $router.push(`/machines/${id}/eva/${row.id}`))"
      >
        <table-column-date/>
        <el-table-column prop="marker" label="Маркер"/>
        <el-table-column prop="is_valid" label="">
          <template slot-scope="{row}"><div v-if="!row.is_valid" class="text-danger">Ошибка</div></template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>
<script>
  import api from '@/api'
  import BtnAction from '../../../../components/btn-action'

  export default {
    components: {BtnAction},
    props: ['id', 'machine'],
    data () {
      return {
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
      }
    },
    methods: {
      deleteInvalids () {
        if (window.confirm('Удалить все отчёты с ошибкой?')) {
          return api
            .delete(`eva/invalid/${this.id}`)
            .then(() => window.alert('Отчёты с ошибкой будут удалены в ближейшее время'))
        }
      },
      deleteAll () {
        if (window.confirm('Удалить все отчёты?')) {
          return api
            .delete(`eva/all/${this.id}`)
            .then(() => window.alert('Отчёты будут удалены в ближейшее время'))
        }
      },
      sendEva () {
        if (window.confirm(`Запросить отчет?`)) {
          return api.post(`modems/${this.machine.modem.uid}/commands`, {
            type: 'eva',
          })
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/eva/index.vue